class ModalContainer extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector("modal-viewer");
    this.modalOverlay = this.querySelector("modal-overlay");
    this.modalButton = this.querySelector("modal-button");
    this.modalContent = this.querySelector("modal-content");
    this.modalClose = this.querySelector("modal-close");

    this.modalButton?.addEventListener("click", () => this.toggleModal());
    this.modalClose?.addEventListener("click", () => this.toggleModal());
    this.modalOverlay?.addEventListener("click", () => this.toggleModal());
    if (this.modalButton?.hasAttribute("disabled") && this.modalButton?.classList.contains("personalise-button")) {
      this.modalButton?.classList.add("disabled");
    }
  }

  toggleModal() {
    if (this.modalButton.classList.contains("personalise-button")) {
      let isPincodeEntered;
      let customPincode = document.querySelector("pincode-element");
          if (customPincode) {
            isPincodeEntered = checkForCustomPincode();
          } else {
            isPincodeEntered = checkForPincode();
          }
      if (!isPincodeEntered) {
        return;
      }
    }
    document.body.classList.toggle("overflow-hidden");
    this.modal.classList.toggle("active");
    document.body.classList.toggle('modal-open');
  }
}
customElements.define("modal-container", ModalContainer);

class ConfirmDialog extends ModalContainer {
  constructor() {
    super();
    this.modalOverlay.replaceWith(this.modalOverlay.cloneNode(true));
    this.confirmButton = this.querySelector("modal-confirm");
    this.cancelButton = this.querySelector("modal-cancel");
    this.confirmButton?.addEventListener("click", () => this.confirmAction());
    this.cancelButton?.addEventListener("click", () => this.cancelAction());
  }

  confirmAction() {
    this.dispatchEvent(new CustomEvent("actionConfirmed"));
    this.toggleModal();
  }

  cancelAction() {
    this.dispatchEvent(new CustomEvent("actionAborted"));
    this.toggleModal();
  }
}

customElements.define("confirm-dialog", ConfirmDialog);